import { useNavigate } from "react-router";
import { useSnackbar } from "notistack";
import { logout } from "../services/authService.js";

/**
 * Ends the session and sends the browser to the login - but only once
 * `logout()` actually succeeded. Navigating on a failed logout would leave
 * the session intact while showing the login page, and the "already signed
 * in" redirect there would just bounce the user straight back.
 *
 * @returns {() => Promise<void>} Call on a logout click.
 */
export function useLogout() {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();

  return async () => {
    try {
      await logout();
      navigate("/login", { replace: true });
    } catch {
      enqueueSnackbar(
        "Abmelden fehlgeschlagen. Bitte versuchen Sie es erneut.",
        {
          variant: "error",
        }
      );
    }
  };
}
